import { render, staticRenderFns } from "./myinvoice.vue?vue&type=template&id=a9487fcc&"
import script from "./myinvoice.vue?vue&type=script&lang=js&"
export * from "./myinvoice.vue?vue&type=script&lang=js&"
import style0 from "./myinvoice.vue?vue&type=style&index=0&id=a9487fcc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports